import React, { useEffect } from 'react';

import useSearchInput from '@dashboard/hooks/useSearchInput';
import { cn } from '@dashboard/lib/utils';
import { Input } from '@dashboard/components/ui/input';
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/solid';

import Label from './Label';

// TODO(no-use-effect): SearchInput uses `useEffect(() => onChange(search), [search])`
// to relay its debounced value, which violates the no-useEffect rule (Rule 3).
//
// As a side effect of that design, `initialValue` is captured once on mount via
// useSearchInput's useState — so if a parent ever updates the search query param
// while keeping SearchInput mounted (e.g. a future "Clear all filters" button),
// the visible field will not reflect the new value. Not currently reachable in
// practice; deferred to a focused PR alongside the no-useEffect refactor.
const SearchInput = ({ name, placeholder, onChange, label, initialValue = '', className }) => {
  const { searchInput, setSearchInput, search } = useSearchInput(initialValue);

  useEffect(() => {
    onChange(search);
  }, [search]);

  return (
    <div className={cn('w-64', className)}>
      {label && <Label>{label}</Label>}
      <div className="relative">
        <Input
          name={name}
          type="text"
          value={searchInput}
          onChange={e => setSearchInput(e.target.value)}
          placeholder={placeholder}
          aria-label={placeholder}
          autoComplete="off"
          className="pr-10"
        />

        <div className="absolute inset-y-0 right-2 flex items-center pointer-events-none">
          {searchInput?.length > 0 && (
            <button
              type="button"
              onClick={() => setSearchInput('')}
              className="pr-2 text-gray-500 dark:text-muted-foreground hover:text-gray-700 dark:hover:text-muted-foreground pointer-events-auto"
              aria-label="Clear search"
            >
              <XMarkIcon className="w-4 h-4" />
            </button>
          )}

          <MagnifyingGlassIcon className="text-gray-300 dark:text-muted-foreground w-4 h-4" />
        </div>
      </div>
    </div>
  );
};

export default SearchInput;
